import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 27, height: 26, viewBox: "0 0 27 26", fill: "#212121", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.52356 19.5555C3.78629 20.3001 2.57914 20.3001 1.84146 19.5555C1.10337 18.8109 0.5 18.2019 0.5 18.2019L13.2414 5.34119L15.9235 8.04881L15.9175 8.05483L26.0149 18.2467L24.6738 19.6003C23.9357 20.3449 22.729 20.3449 21.9913 19.6003L20.6503 18.2467L13.2352 10.7622L5.86461 18.2019L4.52356 19.5555Z" }));
const ForwardRef = forwardRef(SvgLogo);
export default ForwardRef;
